import { api, type SessionBoundRequestConfig } from "./client";

export interface DeletionRequestStatus {
  request: { id: number; status: "requested" | "withdrawn"; requested_at: string; withdrawn_at: string | null } | null;
  workflow: "manual_review";
}

export async function getDeletionRequest(expectedSession: string | null, signal?: AbortSignal) {
  const config: SessionBoundRequestConfig = { expectedSession, signal };
  return (await api.get<DeletionRequestStatus>("/privacy/deletion-request", config)).data;
}

export async function submitDeletionRequest(password: string, expectedSession: string | null, signal: AbortSignal) {
  const config: SessionBoundRequestConfig = { expectedSession, signal };
  return (await api.post<DeletionRequestStatus>("/privacy/deletion-request",
    { password, acknowledge_request_only: true }, config)).data;
}

export async function withdrawDeletionRequest(requestId: number, password: string,
  expectedSession: string | null, signal: AbortSignal) {
  const config: SessionBoundRequestConfig = { expectedSession, signal };
  return (await api.post<DeletionRequestStatus>("/privacy/deletion-request/withdraw",
    { request_id: requestId, password }, config)).data;
}

export function deletionRequestError(error: unknown): string {
  const code = (error as { response?: { data?: { detail?: { code?: unknown } } } })?.response?.data?.detail?.code;
  if (code === "invalid_password" || code === "demo_read_only" || code === "rate_limited" || code === "request_changed") return code;
  return "unavailable";
}
